import { Pipe, PipeTransform } from '@angular/core';
import * as dayjs from 'dayjs'
import * as timezone from 'dayjs/plugin/timezone' 
import * as utc from 'dayjs/plugin/utc' 

dayjs.extend(utc)
dayjs.extend(timezone)

//import 'moment-timezone';

@Pipe({
  name: 'dateEventStart' //this is used in html templates
})
export class DateEventStartPipe implements PipeTransform {

  transform(value: string, lang:string): String {
            
    var thisDate = value;
    if (thisDate != null && thisDate.length != 0) {
        
        if (lang === 'si') {
                //return dayjs(thisDate).tz('Europe/Berlin').format('D. MMM, HH:mm').toLowerCase(); //use dayjs.js 
                return dayjs(thisDate).locale('sl').tz('Europe/Berlin').format('D. MMMM').toLowerCase(); //use dayjs.js 
            }
    
        //return dayjs(thisDate).tz('Europe/Berlin').format('MMM D, HH:mm'); //use dayjs.js 
        return dayjs(thisDate).tz('Europe/Berlin').format('MMM D'); //use dayjs.js 
    }
    return '';
  }

}
